export enum DropdownVariantEnum {
	ORDER_DETAILS = 'orderDetails',
	ORDER_CHANGE = 'orderChange',
	ORDER_CANCEL = 'orderCancel',
	POSITION_INFO = 'positionInfo',
	POSITION_OPTION_INFO = 'positionOptionInfo',
	POSITION_OPTION_CLOSE = 'positionOptionClose',
	POSITION_OPTION_EXECUTION = 'positionOptionExecute',
	POSITION_SLTP = 'positionSlTp',
	POSITION_CLOSE = 'positionClose',
	OPTION_CREATE_ORDER = 'optionCreateOrder',
	OPTION_CANCEL_ORDER = 'optionCancelOrder',
	OPTION_INFO_ORDER = 'optionInfoOrder',
	OPTION_CHANGE_ORDER = 'optionEditOrder',
	POST_TRADING_INFO = 'postTradingInfo',
}
